const currencies = [
    { symbol: "$", isoCode: "USD", name: "United States Dollar", locale: "en-US" },
    { symbol: "$", isoCode: "CAD", name: "Canadian Dollar", locale: "en-CA" },
    { symbol: "$", isoCode: "MXN", name: "Mexican Peso", locale: "es-MX" },
    { symbol: "R$", isoCode: "BRL", name: "Brazilian Real", locale: "pt-BR" },
    { symbol: "$", isoCode: "ARS", name: "Argentine Peso", locale: "es-AR" },
    { symbol: "$", isoCode: "CLP", name: "Chilean Peso", locale: "es-CL" },
    { symbol: "$", isoCode: "COP", name: "Colombian Peso", locale: "es-CO" },
    { symbol: "₡", isoCode: "CRC", name: "Costa Rican Colón", locale: "es-CR" },
    { symbol: "Q", isoCode: "GTQ", name: "Guatemalan Quetzal", locale: "es-GT" },
    { symbol: "L", isoCode: "HNL", name: "Honduran Lempira", locale: "es-HN" },
    { symbol: "C$", isoCode: "NIO", name: "Nicaraguan Córdoba", locale: "es-NI" },
    { symbol: "B/.", isoCode: "PAB", name: "Panamanian Balboa", locale: "es-PA" },
    { symbol: "S/", isoCode: "PEN", name: "Peruvian Sol", locale: "es-PE" },
    { symbol: "$", isoCode: "UYU", name: "Uruguayan Peso", locale: "es-UY" },
    { symbol: "Bs.", isoCode: "VEF", name: "Venezuelan Bolívar", locale: "es-VE" },
    { symbol: "$", isoCode: "DOP", name: "Dominican Peso", locale: "es-DO" },
    { symbol: "$", isoCode: "BBD", name: "Barbadian Dollar", locale: "en-BB" },
    { symbol: "$", isoCode: "TTD", name: "Trinidad and Tobago Dollar", locale: "en-TT" },
    { symbol: "$", isoCode: "JMD", name: "Jamaican Dollar", locale: "en-JM" },
    { symbol: "$", isoCode: "BZD", name: "Belize Dollar", locale: "en-BZ" },
];

export default currencies;